import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useTransferReasonService from '../../../app/services/hooks/useTransferReasonService';

interface Props {
    transferReasonId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const TransferReasonSwitchChange = ({ transferReasonId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeTransferReason, fetchingActiveTransferReason } = useTransferReasonService();

    const active = (value: boolean) => {
        setChecked(value);

        activeTransferReason(transferReasonId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={transferReasonId} callback={active} />;
};

export default TransferReasonSwitchChange;
